import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import Widgets from "../pages/Dashboard/Index";

// Authentication pages
import Basic404 from "../pages/Authentication/Basic404.js";
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import ResetPasswordForm from "../pages/Authentication/ResetPassword.js";
import UserProfile from "../pages/Authentication/userProfile.js";
import Users from "../pages/Users/Index";
import News from "../pages/News/Index.js";
import Posts from "../pages/Posts/index.js";
import GroupChats from "../pages/GroupChat/index.js";
import PolicyPage from "../pages/Policy/Index.js";
import TermsPage from "../pages/Terms/Index.js";
import ContectUs from "../pages/ContactUs/index.js";
import Subscription from "../pages/Subscription/index.js";
import DrawingsHistory from "../pages/DrawingsHistory/index.js";

const authProtectedRoutes = [
  // Dashboard
  { path: "/dashboard", component: <Widgets /> },
  // Drawings History
  { path: "/drawings-history", component: <DrawingsHistory /> },
  // Other pages
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/404" /> },

  // Profile
  { path: "/profile", component: <UserProfile /> },

  // Users
  { path: "/users", component: <Users /> },

  //news
  { path: "/news", component: <News /> },

  // Posts
  { path: "/posts", component: <Posts /> },

  // Chats
  { path: "/chats", component: <GroupChats /> },

  // Policy & Terms
  { path: "/privacy-policy", component: <PolicyPage /> },
  { path: "/terms-and-conditions", component: <TermsPage /> },

  // Contact Us
  { path: "/contact-us", component: <ContectUs /> },

  //Subscriptions
  { path: "/subscriptions", component: <Subscription /> },

];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPasswordForm /> },
  { path: "/404", component: <Basic404 /> },
];

export { authProtectedRoutes, publicRoutes };
